<template>
	<div class="login-content">
		<h1 class="text-left mb-5">{{$t('新生報到登入')}}</h1>
		<Card>
			<Form class="login-form" ref="form" :model="form" :rules="rule">
				<FormItem prop="UserId">
					<Input type="text" v-model="form.UserId" :placeholder="$t('身分證字號或護照號碼')">
						<Icon type="ios-person-outline" slot="prepend"></Icon>
					</Input>
				</FormItem>
				<FormItem prop="UserPassword" align="left">
					<Input
						type="password"
						v-model="form.UserPassword"
						@on-enter="handleSubmit"
						:placeholder="$t('密碼')"
					>
						<Icon type="ios-lock-outline" slot="prepend"></Icon>
					</Input>
					<a type="text" @click="handleForgetPassword">{{$t('忘記密碼')}}</a>
				</FormItem>
				<FormItem>
					<Button type="primary" long @click="handleSubmit" :loading="isLoading">{{$t('登入')}}</Button>
				</FormItem>
			</Form>
		</Card>
	</div>
</template>
<script>
export default {
	data: function() {
		return {
			form: {
				UserId: '',
				UserPassword: '',
				From: 'Student',
			},
			rule: this.getRules(),
			isLoading: false,
		}
	},
	methods: {
		getRules() {
			return {
				UserId: [
					{
						required: true,
						message: this.$t('請輸入帳號'),
						trigger: 'blur',
					},
				],
				UserPassword: [
					{
						required: true,
						message: this.$t('請輸入密碼'),
						trigger: 'blur',
					},
				],
			}
		},
		handleSubmit() {
			this.$refs.form.validate(async valid => {
				if (valid) {
					try {
						this.isLoading = true
						let response = await this.$http.post('api/login', this.form)
						this.$router.push('/home')
					} catch (error) {
						if (error.response.data) {
							this.$Message.error(this.$t(error.response.data.Message))
						} else {
							this.$Message.error(this.$t('帳號或密碼不正確'))
						}
					} finally {
						this.isLoading = false
					}
				}
			})
		},
		handleForgetPassword() {
			this.$router.push(`/password/forget`)
		},
	},
	watch: {
		'$i18n.locale': function() {
			this.rule = this.getRules()
		},
	},
}
</script>
<style>
.login-content {
	margin-top: 60px;
	padding-top: 50px;
	padding-bottom: 50px;
	width: 500px;
	margin: auto;
}
.login-form {
	padding: 50px 70px 30px 70px;
}
</style>
